export default __webpack_public_path__ + "static/media/art-red-banner-1.d5635e67.jpg";